import { useBrandBreadcrumbs } from '@/modules/breadcrumbs/useBrandBreadcrumbs';
import { useCategoryBreadcrumbs } from '@/modules/breadcrumbs/useCategoryBreadcrumbs';
import { type Brand } from '@/modules/cms/types';

export function useBrandCategoryBreadcrumbs({
  brand,
  categoryPathname,
  enabled = true,
}: {
  brand?: Brand;
  categoryPathname: string;
  enabled?: boolean;
}) {
  const brandBreadcrumbs = useBrandBreadcrumbs(brand);
  const lastBrandBreadcrumbSlug =
    brandBreadcrumbs[brandBreadcrumbs.length - 1]?.link;

  const { data: categoryBreadcrumbsRes } = useCategoryBreadcrumbs({
    categoryPathname,
    linkPrefix: `${lastBrandBreadcrumbSlug}/c`,
    enabled,
  });
  const categoryBreadcrumbs = categoryBreadcrumbsRes || [];

  return [...brandBreadcrumbs, ...categoryBreadcrumbs];
}
